import {
    AgencyProfileOption,
    DispatchAreaOption,
    EventPanelFormType,
    RadioChannelOption,
} from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { Box, DataList, DataItem } from '@cad-arc';
import { SubdivisionFieldParam } from '../common/types';

function FREventSubdivisionsDatalist({
    eventForm,
    subdivisionsFieldsValues,
    isEmsAgency,
}: {
    eventForm: UseFormReturn<EventPanelFormType>;
    subdivisionsFieldsValues: SubdivisionFieldParam[];
    isEmsAgency?: boolean;
}) {
    return (
        <DataList
            direction="row"
            style={{ width: isEmsAgency ? '50%' : '100%', marginBottom: '16px', gap: '80px' }}
        >
            {subdivisionsFieldsValues?.map((field) => {
                const subdivisionValue = eventForm.getValues(field.name);

                return (
                    <DataItem key={field.name} dataKey={field.label}>
                        {subdivisionValue?.label}
                    </DataItem>
                );
            })}
        </DataList>
    );
}

export function EventFormFieldsByAgencyGlobalType({
    eventForm,
    subdivisionsFieldsValues,
    dispatchAreaValue,
    agencyValue,
    primaryRadioChannelValue,
    isPoliceAgency = false,
    isEmsAgency = false,
}: {
    eventForm: UseFormReturn<EventPanelFormType>;
    subdivisionsFieldsValues?: SubdivisionFieldParam[];
    dispatchAreaValue: DispatchAreaOption | null;
    agencyValue: AgencyProfileOption | null;
    primaryRadioChannelValue: RadioChannelOption | null;
    isPoliceAgency?: boolean;
    isEmsAgency?: boolean;
}) {
    return (
        <Box mb={4}>
            {subdivisionsFieldsValues?.length && (
                <FREventSubdivisionsDatalist
                    eventForm={eventForm}
                    subdivisionsFieldsValues={subdivisionsFieldsValues}
                    isEmsAgency={isEmsAgency}
                />
            )}
            <DataList direction="row" style={{ marginBottom: '16px' }}>
                <DataItem dataKey="D-Area" style={{ flexBasis: '50%' }}>
                    {dispatchAreaValue?.label}
                </DataItem>
                <DataItem dataKey="Agency" style={{ flexBasis: '50%' }}>
                    {agencyValue?.label}
                </DataItem>
            </DataList>
            <DataList direction="row">
                <DataItem dataKey={isPoliceAgency ? 'Radio Channel' : 'Primary Radio Channel'}>
                    {primaryRadioChannelValue?.label}
                </DataItem>
            </DataList>
        </Box>
    );
}
